import React, { forwardRef } from "react";
import { variables } from "../../assets/styles";
const AiIcon = forwardRef((props, ref) => {
    return (React.createElement("svg", { ...props, ref: ref, width: "100%", height: "100%", viewBox: "0 0 24 24" },
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: "nitroGradient" },
                React.createElement("stop", { offset: "0%", stopColor: variables.nitro_gradient_start }),
                React.createElement("stop", { offset: "100%", stopColor: variables.nitro_gradient_end }))),
        React.createElement("path", { fill: "url(#nitroGradient)", d: "m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25z" })));
});
AiIcon.displayName = "AiIcon";
export default AiIcon;
//# sourceMappingURL=AiIcon.js.map